module.exports = __webpack_public_path__ + "h5/img/userBgs.b66c9fee.jpg";